import {
  ReduxListFilterStreamedContainer,
  ReduxListStreamedContainer,
} from '../../../core-utilities/redux/ReduxListContainer';
import {componentOptions, reduxList} from '../../redux/peopleSelectorList';
import {PeopleSelectorListComponent} from './PeopleSelectorListComponent';


const ListComponent = ReduxListStreamedContainer(PeopleSelectorListComponent, reduxList, componentOptions);
export const PeopleSelectorListContainer = ReduxListFilterStreamedContainer(ListComponent, reduxList, componentOptions);



// WEBPACK FOOTER //
// ./src/js/personnel/components/PeopleSelectorList/PeopleSelectorListContainer.js